// The 1v1 baseline: the best duel bot found so far, the one every attempt to
// improve the 1v1 bots has to beat. From the trait sweep's tournament
// (tools/bots/duel-sweep.md, 2026-10-01): maxed on skill, a mild daredevil that
// hunts cut-offs and keeps room ahead. Tied for first (+36 Elo over the neutral
// sweep bot at 32,000 games each) with two even more daredevil variants; this
// is the least extreme of the three. Greed is 0: it made no difference in 1v1.
export var DUEL_BASELINE = {
    id: "duel-baseline-v1",
    traits: { planning: 1, breadth: 1, precision: 1, caution: -0.66, aggression: 1, space: 0.66, greed: 0 },
};
